import { ReactComponent as PriorityNoneIcon } from '@ubeya/shared-web/assets/help-desk/priority-none.svg';
import { ReactComponent as PriorityLowIcon } from '@ubeya/shared-web/assets/help-desk/priority-low.svg';
import { ReactComponent as PriorityMediumIcon } from '@ubeya/shared-web/assets/help-desk/priority-medium.svg';
import { ReactComponent as PriorityHighIcon } from '@ubeya/shared-web/assets/help-desk/priority-high.svg';
import { ReactComponent as FileTypeFileIcon } from '@ubeya/shared-web/assets/file-icon.svg';
import { ReactComponent as FileTypePdfIcon } from '@ubeya/shared-web/assets/pdf-icon.svg';
import { ReactComponent as FileTypeWordIcon } from '@ubeya/shared-web/assets/word-doc-icon.svg';
import { ReactComponent as FileTypeExcelIcon } from '@ubeya/shared-web/assets/excel-icon.svg';

export { HELP_DESK_ICON_MAP } from '../settings/components/AccountSettings/HelpDeskSettings/constants';

export const PRIORITY_ICON_MAP = {
  NONE: PriorityNoneIcon,
  LOW: PriorityLowIcon,
  MEDIUM: PriorityMediumIcon,
  HIGH: PriorityHighIcon
};

export const VISIBLE_PRIORITIES = ['NONE', 'LOW', 'MEDIUM', 'HIGH'];

export const FILE_TYPE_ICON_MAP = {
  pdf: { Icon: FileTypePdfIcon, labelKey: 'help_desk_file_type_pdf' },
  word: { Icon: FileTypeWordIcon, labelKey: 'help_desk_file_type_word' },
  excel: { Icon: FileTypeExcelIcon, labelKey: 'help_desk_file_type_excel' },
  other: { Icon: FileTypeFileIcon, labelKey: 'help_desk_file_type_other' }
};

export const ALLOWED_IMAGE_EXTENSIONS = ['jpeg', 'jpg', 'gif', 'png'];
export const ALLOWED_VIDEO_EXTENSIONS = ['mp4', 'mov', 'qt', 'avi'];
export const ALLOWED_PDF_EXTENSIONS = ['pdf'];
export const ALLOWED_WORD_EXTENSIONS = ['doc', 'docx'];
export const ALLOWED_EXCEL_EXTENSIONS = ['xlsx', 'csv'];
export const ALLOWED_OTHER_EXTENSIONS = [
  ...ALLOWED_PDF_EXTENSIONS,
  ...ALLOWED_WORD_EXTENSIONS,
  ...ALLOWED_EXCEL_EXTENSIONS,
  'ppt',
  'pptx',
  'json',
  'eai',
  'ok',
  'txt'
];
export const MAX_ATTACHMENT_FILE_SIZE_MB = 30;
export const MAX_ATTACHMENT_FILE_SIZE_BYTES = MAX_ATTACHMENT_FILE_SIZE_MB * 1024 * 1024;
